import clsx from "clsx"

import { Button, Icon } from "@atoms"

import styles from "./EmptyState.module.scss"
import { EmptyStateProps } from "./EmptyState.types"

export default function EmptyState(props: EmptyStateProps) {
    const { variant, icon, title, supportText, primaryCTA, secondaryCTA } = props

    return (
        <div
            className={clsx(styles.base, {
                [styles.error]: variant === "error",
            })}
        >
            <div className={styles.iconAndCopy}>
                {icon && (
                    <div className={styles.icon}>
                        <Icon icon={icon} size={16} container="fixedHeight" />
                    </div>
                )}
                <div className={styles.copyWrapper}>
                    <span className={styles.title}>{title}</span>
                    {supportText && <span className={styles.supportText}>{supportText}</span>}
                </div>
            </div>
            {(primaryCTA || secondaryCTA) && (
                <div className={styles.ctaContainer}>
                    {primaryCTA && <Button {...primaryCTA} variant="subtle" size="lg" />}
                    {secondaryCTA && <Button {...secondaryCTA} variant="ghost" size="lg" />}
                </div>
            )}
        </div>
    )
}
